import styled from 'styled-components';

export const Difficulty = styled.span`
    text-transform: capitalize;
`;
